module.exports = __webpack_public_path__ + "static/media/ci.11ac689d.svg";